import { accountsFilterAtom } from 'atoms/filters/sim-products';
import { accountsHintsAtom } from 'atoms/hints/sim-products';
import { AccountSearchFilter } from 'common/components/Filters/Inputs/accounts/AccountSearchFilter';

export const AccountSearchInput = () => {
  return (
    <AccountSearchFilter
      accountsFilterAtom={accountsFilterAtom}
      accountsHintsAtom={accountsHintsAtom}
    />
  );
};
